/**
 * Create a roster module with the default handlers that defer all requests to falcor
 *
 * @param {string} modulePath The branch path at which the module is grafted
 *
 * @returns {function} Roster module factory
 */
function createModuleWithDefaults(modulePath) {
  return () => (musterApp, falcorModel, defaultHandlers) =>
    musterApp.match(modulePath, defaultHandlers);
}

module.exports = createModuleWithDefaults;
